// ============ Serializer Types & Registry ============

import {
  defaultEditorSettings,
  DefaultEditorSettingsType,
} from './supportedApplicationSettings'
import { SupportedCardEditorSettingsType } from './types'

interface BaseSerializer<T> {
  deserialize(json: string): T
  serialize(settings: T): string
}

// ============ Serializers ============

class CardEditorSerializer
  implements BaseSerializer<SupportedCardEditorSettingsType>
{
  deserialize(json: string): DefaultEditorSettingsType {
    try {
      const data = JSON.parse(json)
      if (typeof data !== 'object' || data === null)
        return defaultEditorSettings
      const obj = data as Record<string, unknown>
      const requiredKeys = Object.keys(
        defaultEditorSettings,
      ) as (keyof DefaultEditorSettingsType)[]
      let validated = {}

      for (const key of requiredKeys) {
        if (!(key in obj)) {
          validated = { ...validated, [key]: defaultEditorSettings[key] }
        } else {
          validated = { ...validated, [key]: obj[key] }
        }
      }
      return validated as DefaultEditorSettingsType
    } catch (error) {
      return defaultEditorSettings
    }
  }

  serialize(settings: SupportedCardEditorSettingsType): string {
    return JSON.stringify(settings)
  }
}

// ============ Serializer Registry ============

export const serializerRegistry: {
  card_editor: CardEditorSerializer
} = {
  card_editor: new CardEditorSerializer(),
}
